import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/bookonline-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-5c8ef089"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full shadow gap-4 p-4 mb-8 flex flex-col md:flex-row justify-between items-center md:p-4 md:min-h[64px]"
}
const _hoisted_2 = { class: "flex flex-col md:flex-row items-center gap-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: 100,
  alt: "BookOnline"
}, null, -1))
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_5 = { class: "flex justify-center items-center gap-2" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "font-bold text-sm md:max-w-[200px]" }
const _hoisted_8 = { class: "text-ellipsis overflow-hidden line-clamp-1" }
const _hoisted_9 = { class: "flex justify-center items-center gap-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "block pi pi-user rounded-full p-2 bg-gray-100 shadow" }, null, -1))
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "font-bold text-sm md:max-w-[200px]" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "text-xs" }

import PMenu from "primevue/menu";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const isAdmin = computed(() => store.getters["user/isAdmin"]);
const router = useRouter();
const user = computed(() => store.getters["user/info"]);

const userMenu = ref();
const posMenu = ref();
const toggleUserMenu = (event: any) => userMenu.value.toggle(event);
const isUserMenuShown = computed(() => !!userMenu.value?.overlayVisible);
const togglePosMenu = (event: any) => posMenu.value.toggle(event);
const isUserPosShown = computed(() => !!posMenu.value?.overlayVisible);
const posOptions = computed(() => {
  return store.getters["pos/userAccess"].map((pos: any) => ({
    label: pos.name,
    command: () => {
      store.dispatch("pos/SET_CURRENT_POS_ID", pos.id);
      window.location.href = router.resolve({ name: "Home" }).href;
    },
    disabled: pos.id === currentPos.value?.id,
  }));
});
const currentPos = computed(() => store.getters["pos/currentPos"]);
const userOptions = computed(() => {
  const options = [];
  if (isAdmin.value) {
    options.push({
      label: t("globalSettings"),

      items: [
        // { label: t("informations"), to: { name: "SpacesSettings" } },
        { label: t("language"), to: { name: "LanguageSettings" } },
        { label: t("posList"), to: { name: "PosSettings" } },
        { label: t("teamMembers"), to: { name: "TeamSettings" } },
        { label: t("clients"), to: { name: "ClientsSettings" } },
        { label: t("reviews"), to: { name: "ReviewsSettings" } },
      ],
    });
    options.push({
      label: t("currentPosSettings"),
      items: [
        { label: t("spaces"), to: { name: "SpacesSettings" } },
        { label: t("services"), to: { name: "ServicesSettings" } },
      ],
    });
  }
  options.push({
    label: t("actions"),
    items: [
      {
        label: t("disconnect"),
        command: async () => {
          await store.dispatch("user/LOGOUT");
          await store.dispatch("pos/LOGOUT");
          router.replace({ name: "Login" });
        },
      },
    ],
  });
  return options;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(user))
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: { name: 'Home' },
            class: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: { name: 'ReservationList' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("reservations")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "flex flex-col md:flex-row items-center gap-4 px-4 py-2 md:bg-black md:text-white md:-my-4",
            onClick: togglePosMenu
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentPos)?.name), 1)
                ])
              ]),
              _createElementVNode("i", {
                class: _normalizeClass([[_unref(isUserPosShown) ? 'pi pi-angle-up' : 'pi pi-angle-down'], "block"])
              }, null, 2)
            ]),
            _createVNode(_unref(PMenu), {
              ref_key: "userMenu",
              ref: userMenu,
              model: _unref(userOptions),
              popup: true
            }, null, 8, ["model"])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "flex flex-col md:flex-row items-center gap-4",
            onClick: toggleUserMenu
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", {
                      class: "text-ellipsis overflow-hidden line-clamp-1",
                      title: `${_unref(user)?.firstName} ${_unref(user)?.lastName}`
                    }, _toDisplayString(_unref(user)?.firstName) + " " + _toDisplayString(_unref(user)?.lastName), 9, _hoisted_13)
                  ]),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t(_unref(currentPos)?.role)), 1)
                ]),
                _createElementVNode("i", {
                  class: _normalizeClass([[_unref(isUserMenuShown) ? 'pi pi-angle-up' : 'pi pi-angle-down'], "block p-2"])
                }, null, 2)
              ]),
              _createVNode(_unref(PMenu), {
                ref_key: "posMenu",
                ref: posMenu,
                model: _unref(posOptions),
                popup: true
              }, null, 8, ["model"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})